// extracted by mini-css-extract-plugin
export default {"left":"xF_wS","right":"xF_wT","card":"xF_mL","container":"xF_gw"};